import { isEmpty } from 'lodash';
import { mapState } from 'vuex';
import { LOCALE_DEFAULT } from '@model/const/locales.ts';

export default {
    computed: {
        ...mapState({
            licensesItems: (state) => state.licenses.data,
            productItems: (state) => state.products.items,
            productID: (state) => state.pages?.page?.product_id,
            storePage: (state) => state.pages?.page || {},
        }),

        pageType() {
            const types = this.$store.state.pages?.types?.items || [];
            const type = types.find((el) => el.id === this.storePage.type_id) || {};
            return type.name || '(not set)';
        },

        pageAudience() {
            const audiences = this.$store.state.pages?.audiences?.items || [];
            const audience = audiences.find((el) => el.id === this.storePage.audience_id) || {};
            return audience.name || '(not set)';
        },

        locale() {
            return this.$store.state.geolocation.finalLocale || LOCALE_DEFAULT;
        },

        brandName() {
            return this.productItems?.[this.productID]?.parameters?.common?.productName || '(not set)';
        },
    },

    methods: {
        ecommerceSendEvent({ event, license }) {
            if (typeof window === 'undefined') return;

            if (!license?.cleverbridge_id) {
                return;
            }

            const result = {
                event: 'AcronisEcommerce',
                eventLabel: event.eventLabel || license.name || '',
                eventAction: event.eventAction || 'Add to cart',
                eventContext: event.eventContext || 'click',
                eventCategory: event.eventCategory || 'Conversions',
                eventContent: this.productItems?.[this.productID]?.name || '(not set)',
                eventLocation: this.pageType,
                eventProductName: license.name || '',
                eventProductPrice: license.price || '',
                eventProductId: Number(license.cleverbridge_id) || null,
                eventPosition: 1,
                ecommerce: {},
            };

            const quantity = event.quantity || 1;
            const type = event?.ecommerce?.type || '';
            const products = [this.ecommerceLicense(license, quantity)];

            result.ecommerce[type] = {
                products,
                currencyCode: this.productCurrency,
                actionField: { list: this.pageType },
            };

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push(result);
        },

        ecommerceProducts(licenses) {
            let count = 0;
            let position = 0;
            let quantity = 1;
            const result = [];

            this.licensesItems.forEach((license) => {
                if (!isEmpty(licenses)) {
                    if (!Object.keys(licenses).includes(license.cleverbridge_id)) {
                        return;
                    }
                    quantity = licenses[license.cleverbridge_id];
                }

                if (!result[count]) {
                    result[count] = [];
                }

                position += 1;

                if (!result[count].find((item) => item.id === license.cleverbridge_id)) {
                    result[count].push(this.ecommerceLicense(license, quantity, position));
                }

                if (isEmpty(licenses) && !(position % 10)) {
                    count++;
                }
            });

            return result;
        },

        ecommerceLicense(license, quantity, position) {
            const name = license?.name || '(not set)';
            const type = name.match(/.*(\d\syears?).*/i) || '';
            const result = /cloud/i.test(name) ? 'Subscription' : 'Perpetual';
            const variant = type ? `Subscription ${type[1]}` : result;

            return {
                list: license.item_list_name || '',
                position: position || 1,
                quantity: quantity || 1,
                brand: this.brandName,
                price: license.price,
                category: this.pageAudience,
                id: Number(license.cleverbridge_id) || null,
                name,
                variant,
                dimension129: license.price_promo || null,
            };
        },
    },
};
